import { useEffect, useRef } from "react";
import { useGoogleCalendarOAuthCallbackMutation } from "../../services/api/user.api";

const GoogleCallbackPage = () => {
  const hasProcessed = useRef(false);
  const [exchangeOAuthCode] = useGoogleCalendarOAuthCallbackMutation();

  useEffect(() => {
    if (hasProcessed.current) {
      return;
    }

    const handleCallback = async () => {
      hasProcessed.current = true;

      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const error = urlParams.get("error");
      const errorDescription = urlParams.get("error_description");
      const state = urlParams.get("state");

      if (error) {
        const errorMessage = errorDescription || "Authentication failed";
        window.opener?.postMessage(
          { type: "GOOGLE_AUTH_ERROR", message: errorMessage },
          window.location.origin
        );
        window.close();
      } else if (code && state) {
        try {
          await handleOAuthSuccess(code, state);
        } catch {
          window.opener?.postMessage(
            { type: "GOOGLE_AUTH_ERROR", message: "Failed to process authentication" },
            window.location.origin
          );
          window.close();
        }
      } else {
        window.opener?.postMessage(
          { type: "GOOGLE_AUTH_ERROR", message: "Invalid callback response" },
          window.location.origin
        );
        window.close();
      }
    };

    const handleOAuthSuccess = async (code: string, state: string) => {
      try {
        const result = await exchangeOAuthCode({ code, state }).unwrap();

        if (result.success) {
          window.opener?.postMessage(
            { type: "GOOGLE_AUTH_SUCCESS", data: result },
            window.location.origin
          );
        } else {
          // console.error("Backend returned error:", result.message);
          window.opener?.postMessage(
            {
              type: "GOOGLE_AUTH_ERROR",
              message: result.message || "Authentication failed",
            },
            window.location.origin
          );
        }
      } catch (error) {
        // console.error("OAuth processing error:", error);
        window.opener?.postMessage(
          { type: "GOOGLE_AUTH_ERROR", message: "Failed to process authentication" },
          window.location.origin
        );
      } finally {
        window.close();
      }
    };

    handleCallback();
  }, [exchangeOAuthCode]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontFamily: "Arial, sans-serif",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <div style={{ fontSize: "18px", color: "#333" }}>
        Processing Google Calendar authentication...
      </div>
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #2f42c2",
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      ></div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default GoogleCallbackPage;
